import {
  Box,
  FormControlLabel,
  Radio,
  RadioGroup,
  Typography,
} from "@mui/material";
import { useRef, useState } from "react";
import ButtonComp from "../../../../components/Button";
import theme from "../../../../theme";

export default function DriverDocs({
  setStep,
  formData,
  setFormData,
  setDocuments,
  documents,
  onSubmit,
}: any) {
  const [errors, setErrors] = useState<Record<string, string>>({});

  const LicenceInputRef = useRef<HTMLInputElement | null>(null);
  const PdpInputRef = useRef<HTMLInputElement | null>(null);

  const handleChange = (e: any) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    setErrors((prev: any) => ({
      ...prev,
      [name]: "",
    }));
  };

  const validateStep2 = () => {
    let newErrors: any = {};

    if (!documents.driver_license) {
      newErrors.driver_license = "Driver license is required";
    }

    if (!formData.hasPdp) {
      newErrors.pdp = "Please select PDP option";
    }

    if (formData.hasPdp === "true" && !documents.driver_pdp) {
      newErrors.driver_pdp = "PDP document is required";
    }

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  const handleBack = () => {
    setStep(1);
  };
  return (
    <Box>
      <Typography
        variant="h4"
        sx={{
          color: theme.palette.primary.main,
          fontSize: { xs: "28px", md: "38px" },
          fontWeight: 600,
          mb: 3,
          textAlign: "center",
        }}
      >
        Driver's Document
      </Typography>

      <Box display="flex" flexDirection="column" gap={2}>
        {/* PDP Radio */}

        <Typography
          variant="subtitle1"
          textAlign="left"
          fontWeight={600}
          fontSize={18}
        >
          Professional Driving Permit(PDP)
        </Typography>
        <RadioGroup
          row
          name="hasPdp"
          value={formData.hasPdp}
          onChange={handleChange}
        >
          <FormControlLabel value="true" control={<Radio />} label="Yes" />
          <FormControlLabel value="false" control={<Radio />} label="No" />
        </RadioGroup>
        <Box>
          <Typography sx={{ fontSize: 18, fontWeight: 600, textAlign: "left" }}>
            Driver Licence
          </Typography>
          <Box
            sx={{
              border: "2px solid #E5E7EB", // ✅ red border on error
              borderRadius: "12px",
              height: 56,
              display: "flex",
              alignItems: "center",
              px: 2,
            }}
          >
            <ButtonComp
              variant="contained"
              sx={{
                backgroundColor: "#6D6D6D",
                borderRadius: "12px",
                height: 36,
                minWidth: 100,
                mr: 2,
              }}
              onClick={() => LicenceInputRef.current?.click()}
            >
              Choose
            </ButtonComp>

            <Typography sx={{ color: "#6B7280" }}>
              {documents.driver_license
                ? documents.driver_license.name
                : "No file chosen"}
            </Typography>

            <input
              type="file"
              hidden
              ref={LicenceInputRef}
              onChange={(e: any) => {
                const file = e.target.files[0];
                setDocuments((prev: any) => ({
                  ...prev,
                  driver_license: file,
                }));

                setErrors((prev: any) => ({
                  ...prev,
                  driver_license: "",
                }));
              }}
            />
          </Box>
          {/* ✅ Error message */}
          {errors.driver_license && (
            <Typography color="error" fontSize={12} mt={0.5}>
              {errors.driver_license}
            </Typography>
          )}
        </Box>

        {/* PDP Upload (only if Yes) */}
        {formData.hasPdp === "true" && (
          <Box>
            <Typography
              sx={{ fontSize: 18, fontWeight: 600, textAlign: "left" }}
            >
              PDP Upload
            </Typography>
            <Box
              sx={{
                border: "2px solid #E5E7EB", // ✅ red border on error
                borderRadius: "12px",
                height: 56,
                display: "flex",
                alignItems: "center",
                px: 2,
              }}
            >
              <ButtonComp
                variant="contained"
                sx={{
                  backgroundColor: "#6D6D6D",
                  borderRadius: "12px",
                  height: 36,
                  minWidth: 100,
                  mr: 2,
                }}
                onClick={() => PdpInputRef.current?.click()}
              >
                Choose
              </ButtonComp>

              <Typography sx={{ color: "#6B7280" }}>
                {documents.driver_pdp
                  ? documents.driver_pdp.name
                  : "No file chosen"}
              </Typography>

              <input
                type="file"
                hidden
                ref={PdpInputRef}
                onChange={(e: any) => {
                  const file = e.target.files[0];

                  setDocuments((prev: any) => ({
                    ...prev,
                    driver_pdp: file,
                  }));
                  setErrors((prev: any) => ({
                    ...prev,
                    driver_pdp: "",
                  }));
                }}
              />
            </Box>
            {/* ✅ Error message */}
            {errors.driver_pdp && (
              <Typography color="error" fontSize={12} mt={0.5}>
                {errors.driver_pdp}
              </Typography>
            )}
          </Box>
        )}
      </Box>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          mt: 5,
        }}
      >
        <ButtonComp
          variant="outlined"
          height={40}
          width={190}
          onClick={handleBack}
        >
          Back
        </ButtonComp>
        <ButtonComp
          variant="contained"
          height={40}
          width={190}
          onClick={() => {
            if (!validateStep2()) return;
            onSubmit();
          }}
        >
          Next
        </ButtonComp>
      </Box>
    </Box>
  );
}
